import * as React from "react";
import {useInputControl} from "../Form/useInputControl";
import {InputFieldProps, InputFieldContainer} from "../InputField";

export interface RadioInputProps extends InputFieldProps, FormRequiredProps {
  onValueChange?: (
    value: string,
    evt: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  name: string;
  onInputChange?: (value: string) => void;
  input?: {value: string | number; error?: string};
  row?: number;
}

interface FormRequiredProps {
  invalidationMessage?: string;
}

export const RadioInputContext = React.createContext({} as RadioInputProps);

export const RadioInput: React.FC<RadioInputProps & InputFieldProps> = ({
  children,
  onValueChange,
  name,
  error,
  invalidationMessage,
  row,
  ...restProps
}) => {
  const initialValue = React.useMemo(() => {
    const childArray = React.Children.toArray(children) as any[];

    if (childArray.length === 1 && childArray[0].props?.value) {
      return childArray[0].props.value;
    }

    const checked = childArray.find((child) => child.props?.defaultChecked);

    return checked?.props?.value ?? "";
  }, [children]);

  const {input, onInputChange} = useInputControl(name, initialValue, "");

  return (
    <RadioInputContext.Provider
      value={{
        name,
        input,
        row,
        onValueChange,
        onInputChange,
      }}
    >
      <InputFieldContainer
        className="flex-wrap"
        error={input?.error}
        {...restProps}
      >
        {children}
      </InputFieldContainer>
    </RadioInputContext.Provider>
  );
};
